export function ConfirmMoveDialog({ confirmMove, onCancel, onConfirm }) {
  return (
    <div className="fixed inset-0 z-50 bg-[#181B34]/40 backdrop-blur-sm flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-sm" data-testid="confirm-move-dialog">
        <h3 className="text-lg font-black tracking-tight">Confirm move</h3>
        <p className="mt-2 text-sm font-medium text-[#4b4e63]">
          Move <span className="font-bold">{confirmMove.emp.full_name}</span>
          {confirmMove.count > 0 && <> and <span className="font-bold">{confirmMove.count} report{confirmMove.count > 1 ? "s" : ""}</span></>} under{" "}
          <span className="font-bold">{confirmMove.target.full_name}</span>?
        </p>
        <div className="mt-5 flex gap-2 justify-end">
          <button data-testid="cancel-move-btn" onClick={onCancel} className="px-4 h-10 rounded-xl font-bold text-[#4b4e63] hover:bg-[#F0F3FF]">Cancel</button>
          <button data-testid="confirm-move-btn" onClick={onConfirm}
            className="px-5 h-10 rounded-xl bg-[#6161FF] text-white font-bold">Move</button>
        </div>
      </div>
    </div>
  );
}
